import { makeStyles, Tooltip } from "@material-ui/core";
import React from "react";
// import useMediaQuery from "@material-ui/core/useMediaQuery"

interface AddressFieldProps {
  address: string;
  enableToolTip: boolean;
  setOpenAddressToolTip: (data: boolean) => void;
}

const useStyles = makeStyles(
  theme => ({
    address: {
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      display: "-webkit-box",
      overflow: "hidden",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        display: "unset"
      }
    }
  }),
  { name: "AddressField" }
);

const AddressField: React.FC<AddressFieldProps> = props => {
  const { address, setOpenAddressToolTip } = props;
  const classes = useStyles(props);

  return (
    <Tooltip
      placement="bottom"
      title={address}
      interactive
      onOpen={() => setOpenAddressToolTip(true)}
      onClose={() => setOpenAddressToolTip(false)}
    >
      <div onClick={e => e.stopPropagation()}>
        <div
          className={classes.address}
          // style={{
          //   WebkitBoxOrient: "vertical",
          //   WebkitLineClamp: 2,
          //   display: "-webkit-box",
          //   overflow: "hidden",
          //   width: "100%"
          //   // whiteSpace: "nowrap",
          //   // textOverflow: "ellipsis"
          // }}
        >
          <span>{address} </span>
        </div>
      </div>
    </Tooltip>
  );
};

export default AddressField;
